/**
 * @description Slider widget kiosque
 */

/* global SliderInt */

(() => {
	// GO 🚀
	const init = () => {
		return new SliderInt('slide-int-kiosk-container', 'kiosk');
	};

	init();
})();
